/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * SkippedOrderDtoBase
 * auto generated base class for the model SkippedOrderDtoModel.
 */
export const SkippedOrderDtoModelBase = ModelBase
  .named('SkippedOrderDto')
  .props({
    __typename: types.optional(types.literal("SkippedOrderDto"), "SkippedOrderDto"),
    orderUuid: types.identifier,
    reason: types.union(types.undefined, types.string),
    errorDetails: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class SkippedOrderDtoModelSelector extends QueryBuilder {
  get orderUuid() { return this.__attr(`orderUuid`) }
  get reason() { return this.__attr(`reason`) }
  get errorDetails() { return this.__attr(`errorDetails`) }
}
export function selectFromSkippedOrderDto() {
  return new SkippedOrderDtoModelSelector()
}

export const skippedOrderDtoModelPrimitives = selectFromSkippedOrderDto().orderUuid.reason.errorDetails
